<template>
  <div class="delete-events text-dark">
    <div class="delete-event__options" v-if="!isInDCalendar">
      <DDropdown>
        <ul slot="list" class="large-list">
          <li @click="setDelete"><span class="icon-bin"></span> {{ i18n[locale].delete_events_onward }}</li>
        </ul>
      </DDropdown>
    </div>
    <div ref="d_modal_delete_event" v-if="isReadyForModal">
      <Modal v-if="isModal" @close="closeModal">
        <div slot="body" class="delete-events___modal text-dark">
          <div class="delete-events___modal__header" :style="{backgroundColor: bgColor}">
            <h2>{{ i18n[locale].are_you_sure }}</h2>
          </div>
          <div class="delete-events___modal__form">
            <h4>{{ i18n[locale].do_you_want_to_delete_this_and_all_in_same_timeslot }}</h4>
            <div class="delete-events___modal__footer">
              <button @click.stop="closeModal">{{ i18n[locale].cancel }}</button>
              <button class="bttn--warning bttn--red bttn marg-10-left" @click="deleteEvents">
                {{ i18n[locale].delete_events_onward }}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
const i18n = {
  da: {
    delete_events_onward: 'Slet lektionen fremadrettet',
    are_you_sure: 'Er du sikker?',
    do_you_want_to_delete_this_and_all_in_same_timeslot: 'Vil du gerne slette denne lektion, og alle der ligger på samme ugedag og i samme tidsrum fremadrettet?',
    cancel: 'Annuller'
  },
  en: {
    delete_events_onward: 'Delete this and on same timeslot forward',
    are_you_sure: 'Are you sure?',
    do_you_want_to_delete_this_and_all_in_same_timeslot: 'Would you like to delete this lesson and all that lie on the same day of the week and in the same time period going forward?',
    cancel: 'Cancel'
  },
  nb: {
    delete_events_onward: 'Slett denne timen nå og fremover',
    are_you_sure: 'Er du sikker?',
    do_you_want_to_delete_this_and_all_in_same_timeslot: 'Vil du slette denne timen og alle tilsvarende planlagte timer i dette faget og tidsrommet fremover i tid?',
    cancel: 'Avbryt'
  }
}
import Modal from '../Subjects/Modal'
import docendo from '../../docendo'
import DDropdown from '../common/DDropdown'

export default {
  components: {Modal, DDropdown},
  props: {
    subjectId: {
      default: '262937'
    },
    eventId: {
      default: '24035264'
    },
    isInDCalendar: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    locale () {
      return this.$store ? this.$store.getters.locale : window.USER.language
    },
    schoolId () {
      return this.$store ? this.$store.getters.schoolId : window.SCHOOL.id
    },
    i18n () {
      return i18n
    },
    bgColor () {
      return this.event && this.event.color ? this.event.color : '#989898'
    }
  },
  data () {
    return {
      isReadyForModal: false,
      isModal: false
    }
  },
  methods: {
    closeModal () {
      this.isReadyForModal = true
      this.isModal = false
      this.$emit('close')
    },
    setDelete () {
      this.isReadyForModal = true
      this.$nextTick(_ => {
        document.getElementById('djs-content-container').appendChild(this.$refs.d_modal_delete_event)
        this.isModal = true
      })
    },
    deleteEvents () {
      let schoolId = this.schoolId
      let eventId = this.eventId
      if (this.event) {
        schoolId = this.event.school_id
        eventId = this.event.event_id
      }
      docendo.eventsDeleteThisAndFollowing(schoolId, eventId, success => {
        // To close event preview panel in ROR
        document.querySelector('body').classList.remove('no-scroll')
        const elCal = document.querySelector('.calendar')
        if (elCal) {
          elCal.click()
        }
        this.$emit('submit')
        this.closeModal()
      }, failure => {
        console.log('something went wront')
      })
    }
  },
  mounted () {
    if (this.isInDCalendar) {
      this.setDelete()
    }
  },
  beforeDestroy () {
    if (this.$refs.d_modal_delete_event) {
      this.$refs.d_modal_delete_event.remove()
    }
  }
}
</script>

<style scoped>
.delete-event__options {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.delete-events___modal__header {
  position: relative;
  transition: background-color 0.4s;
  padding: 30px 20px;
  background-color: #989898;
  border-radius: 4px 4px 0 0;
}

.delete-events___modal__header > h2 {
  color: white;
  margin-top: 0;
}

.delete-events___modal__form {
  position: relative;
  padding: 1rem 2rem;
  overflow-y: scroll;
  max-height: calc(100vh - 10vh - 120px); /* 120px is modal header; 10vh is modal from vtop */
}

.delete-events___modal__footer {
  display: flex;
  justify-content: flex-end;
  padding: 30px 20px 10px;
}

.large-list {
  width: 210px;
}
</style>



// WEBPACK FOOTER //
// DeleteEventOnward.vue?7387a3b0